module.exports = __webpack_public_path__ + "img/廓形.d7cc9209.png";